import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/serviceSalesSaga";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";

const TableOrStackedBarChart = () => {
  const dispatch = useDispatch();
  const {
    data_table: { rows = [], cols = [] },
    options
  } = useSelector((state) => state.serviceSales.chartData);
  const table_view = useSelector((state) => state.serviceSales.selectedFilters.table_view);
  const currencySymbol = useSelector((state) => state.serviceSales.currentUser.currencySymbol);

  return (
    <GoogleChart
      chartName="sales_revenue_service_sales_chart"
      width="1350px"
      height={400}
      isTableView={table_view}
      rows={rows}
      columns={cols}
      options={options}
      enableEventListeners
      currencySymbol={currencySymbol}
      switchView={(data) => dispatch(actionCreators.updateTableView(data))}
    />
  );
};

export default TableOrStackedBarChart;
